// extracted by mini-css-extract-plugin
export default {"pageContainer":"webpack-pages-AutoExclusions-AutoExclusionsPage-module__pageContainer","feedbackButton":"webpack-pages-AutoExclusions-AutoExclusionsPage-module__feedbackButton"};